export default function registerRecovery($, apower) {
  $.registerOnce(".recover-files-ins", {
    init: function () {
      var tHeadLi = $(".recover-files-ins").find(".tab-head li"),
        tBodyLi = $(".recover-files-ins").find(".tab-content .content-item");

      tHeadLi.$on("click touchstart", function (e) {
        var index = tHeadLi.index(e.currentTarget);
        for (var i = 0, len = tHeadLi.length; i < len; i++) {
          tHeadLi.eq(i).removeClass("active");
          tBodyLi.eq(i).css("display", "none");
        }
        $(e.currentTarget).addClass("active");
        tBodyLi.eq(index).css("display", "block");
      });
    },
  });
}
